import React, { useState } from 'react';
import { useEffect } from 'react';

import Label from './Label';
import Select from './Select';

const SortInput = ({ options, onChange, label }) => {
  const [sortOption, setSortOption] = useState(Object.keys(options)[0]);

  useEffect(() => {
    onChange(sortOption);
  }, [sortOption]);

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Select onChange={e => setSortOption(e.target.value)}>
        {Object.keys(options).map(key => (
          <option key={key} selected={key === sortOption} value={key}>
            {options[key].label}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default SortInput;
